import React, { Fragment } from "react";
import { toast } from "react-toastify";

import AUTH_KEY from "@utils/constants/auth";

import t from "../assets/text";

import "react-toastify/dist/ReactToastify.css";

/**
 * Show a success toast notification
 * @param {string} msg - The message to display in the toast
 */
export const show_success_toast = (msg: string): void => {
  toast.success(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="text-primary ms-50 mb-0">Success</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>
  );
};

/**
 * Show a warning toast notification
 * @param {string} msg - The message to display in the toast
 */
export const Warning = (msg: string): void => {
  toast.warning(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="text-danger ms-50 mb-0">Warning</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>
  );
};

/**
 * Show a failure toast notification
 * @param {string} msg - The message to display in the toast
 */
export const show_failure_toast = (msg: string): void => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="text-danger ms-50 mb-0">Failed</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>
  );
};

/**
 * Show a session expiration toast notification
 * @param {string} msg - The message to display in the toast header
 */
export const SessionExpire = (msg: string): void => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="text-danger ms-50 mb-0">{msg}</h6>
        </div>
      </div>
      <div className="toastify-body">{t("toasts.session-expired")}</div>
    </Fragment>,
    {
      toastId: AUTH_KEY.SESSION_EXPIRED, // Prevent duplicate toasts
    }
  );
};
